export const ViewMoreRepliesButton = (props) => {
  const {remainingReplyCount, parentPostId} = props;

  const viewMoreRepliesCopy = `View ${remainingReplyCount} more ${
    remainingReplyCount > 1 ? 'replies' : 'reply'
  }`;

  const showAllReplies = () => {
    const viewButton = document.getElementById(`viewmore-${parentPostId}`);
    const hiddenPosts = document.getElementById(`hiddenposts-${parentPostId}`);
    evite.removeClass(hiddenPosts, 'hidden');
    evite.addClass(viewButton, 'hidden');
  };

  return (
    <button
      type="button"
      onClick={(e) => showAllReplies(e)}
      id={`viewmore-${parentPostId}`}
      className="unstyled-button link large"
      data-qa-id="view-more-replies"
    >
      {viewMoreRepliesCopy}
    </button>
  );
};
